/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Flex, Image, Text } from '@getgo/chameleon-chakra-ui';
import { Link } from '../Link/Link';
import { isMobileJoinTechnicallySupported } from '../../services/ProductCompatibilityService';
import { isMobile } from '../../services/ClientService';
import { GoToAppBanner } from '../Banner/GoToAppBanner';
import { SessionContext } from '../../context/SessionContext';
import { ColorTheme, Spacing } from '../../themes/GoToTheme';

const supportUrl = 'https://support.goto.com/';
const gotoUrl = 'https://www.goto.com/';

const messages = defineMessages({
  support: {
    id: 'header.support',
  },
  ariaGoTo: {
    id: 'goto.header.ariaHomepage',
  },
  infoBannerText: {
    id: 'infoBanner.securityTip',
  },
  infoBannerLink: {
    id: 'infoBanner.securityTipLink',
  },
});

export const GoToHeader: React.FC<{ colorTheme: ColorTheme }> = ({
  colorTheme,
}) => {
  const { formatMessage: f } = useIntl();
  const { product } = useContext(SessionContext);
  const iconHeight = isMobileJoinTechnicallySupported ? '20px' : '30px';
  const colorThemeToLogo: { [key in ColorTheme]: string } = {
    [ColorTheme.light]: 'goto-logo.svg',
    [ColorTheme.dark]: 'goto-logo-dark.svg',
  };
  return (
    <Flex
      direction='column'
      id='header'
      role='heading'
      aria-level={1}
      width='100%'
    >
      {isMobile && <GoToAppBanner product={product} />}
      <Flex padding={Spacing.CoreLayout2} justifyContent='space-between'>
        <Link
          isExternal
          href={gotoUrl}
          color='blue.500'
          aria-label={f(messages.ariaGoTo)}
        >
          <Image
            height={iconHeight}
            src={
              process.env.PUBLIC_URL +
              '/static/media/' +
              colorThemeToLogo[colorTheme]
            }
            alt='GoTo'
          />
        </Link>
        <Link isExternal href={supportUrl}>
          <Text textTransform='uppercase' fontSize='0.8125rem'>
            {f(messages.support)}
          </Text>
        </Link>
      </Flex>
    </Flex>
  );
};
